<template>
  <tbody v-if="value" ref="form1">
    <template v-for="(item, index) in value">
      <tr
        style="
          text-align: left;
          background: #0090a7;
          font-weight: bold;
          color: #fff;
        "
        v-if="canaddteam"
        :key="'space' + index + indexs"
      >
        <td class="text-left">{{ index + 1 }}</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <!-- <td></td>
        <td></td>
        <td></td> -->
      </tr>
      <p
        v-if="name"
        style="padding: 0.625em;white-space: nowrap;"
        :key="'teamNames' + index"
      >
        {{ $lang("中文隊名") }}
      </p>
      <tr :key="'trs' + index + indexs"></tr>
      <tr v-if="name" :key="'trss' + index + indexs">
        <td class="" colspan="11">
          <b-form-group v-if="name" :key="'teamName' + index + indexs">
            <b-form-input
              class="input ui-autocomplete-input"
              style="width: 100%;background: #fff "
              type="text"
              v-model="item.teamName"
              name="teamName"
              :class="errors.has('teamName') && 'is-invalid'"
              v-validate="{ ...rules.name, required: true}"
              :placeholder="$lang('')"
              :disabled="disabled"
            />
            <b-form-invalid-feedback :state="errors.has('teamName')">
              {{ errors.first("teamName") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </td>
      </tr>
      <p
        v-if="name"
        style="padding: 0.625em;white-space: nowrap;"
        :key="'teamNamesOther' + index"
      >
        {{ $lang("外文隊名") }}
      </p>
      <tr :key="'trsOther' + index + indexs"></tr>
      <tr v-if="name" :key="'trssOther' + index + indexs">
        <td class="" colspan="11">
          <b-form-group v-if="name" :key="'teamNameOther' + index + indexs">
            <b-form-input
              class="input ui-autocomplete-input"
              style="width: 100%;background: #fff !important;"
              type="text"
              v-model="item.teamNameOther"
              name="teamNameOther"
              :class="errors.has('teamNameOther') && 'is-invalid'"
              v-validate="{ ...rules.name, required: true }"
              :placeholder="$lang('')"
              :disabled="disabled"
            />
            <b-form-invalid-feedback :state="errors.has('teamNameOther')">
              {{ errors.first("teamNameOther") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </td>
      </tr>
      <tr :key="'tr' + index + indexs"></tr>
      <p
        v-if="contact"
        style="padding: 0.625em;white-space: nowrap;"
        :key="'contacts' + index + indexs"
      >
        {{ $lang("TEXT_TEAM_CONTACT") }}
      </p>
      <lead-forms
        :inputlist="inputlist"
        :keys="indexs"
        :Index="index"
        v-if="contact"
        :key="'contact' + index + indexs"
        :requiredType="requiredType"
        :value.sync="item.contact"
        :rules="rules"
        ref="form-item"
        :disabled="disabled"
      >
      </lead-forms>
      
      <p
        v-if="lead"
        style="padding: 0.625em;white-space: nowrap;"
        :key="'leads' + index + indexs"
      >
        {{ $lang("領隊") }}
      </p>
      <lead-forms
        :noborder="true"
        :inputlist="inputlist"
        :keys="indexs"
        :Index="index"
        v-if="lead"
        :key="'lead' + index + indexs"
        :requiredType="requiredType"
        :value.sync="item.lead"
        :rules="rules"
        ref="form-item"
        :disabled="disabled"
      >
      </lead-forms>
      <tr v-if="number" style="border-top:none"  :key="'color' + index + indexs">
        <td :colspan="$getLocale() === 'zh-hant'?3:8">
            <b-form-group
              horizontal
              :label-cols="3"
              :label="`${$lang('FIELD_COLOR')}：`"
              :key="'color' + index + '|' + indexs"
            >
              <b-form-input
                class="input ui-autocomplete-input"
                style="width: 100%;background: #fff;"
                type="text"
                v-model="item.color"
                :name="'color' + index + '|' + indexs"
                :class="errors.has(`color${index}|${indexs}`) && 'is-invalid'"
                v-validate="{ required: false }"
                :placeholder="sportTitle=='Futebol'?$lang('請填寫守門員及球員球衣顏色'):$lang('')"
              />
              <b-form-invalid-feedback
                :state="errors.has(`color${index}|${indexs}`)"
              >
                {{ errors.first(`color${index}|${indexs}`) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </td>
      </tr>
      <tr
        v-if="canaddteam || errors.has(`${item.gameId}submiterror${index}`)"
        :key="'隊伍成員' + index + indexs"
      >
        <td style="padding: 0.625em !important" colspan="8">
          <div class="row" :class="canaddteam ? '' : 'justify-content-center'">
            <p
              class="col-12 text-left"
              v-if="canaddteam"
              style="padding: 0.625em"
            >
              {{ $lang("隊伍成員")
              }}<span v-if="max == 6"
                >({{ $lang("每隊最多可填寫6名參加者") }})</span
              ><span v-if="max == 12"
                >({{ $lang("每隊最多可填寫12名參加者") }})</span
              >
            </p>
            <b-form-group :key="'error' + index">
              <b-form-input
                class="input ui-autocomplete-input"
                style="width: 100%; height: 0px; padding: 0; border: none"
                type="text"
                :name="item.gameId + 'submiterror' + index"
                :class="
                  errors.has(`${item.gameId}submiterror${index}`) &&
                    'is-invalid'
                "
                v-validate="{ required: false }"
                :placeholder="$lang('')"
                :disabled="disabled"
              />
              <b-form-invalid-feedback
                :state="errors.has(`${item.gameId}submiterror${index}`)"
              >
                {{ errors.first(`${item.gameId}submiterror${index}`) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
        </td>
      </tr>

      <template v-for="(items, indexs) in item.gamer">
        <!-- {{items}} -->
        <publicInstitutions-forms
          :gender="gender"
          @updateValue="changeinput"
          @reset="reset"
          :inputlist="inputlist"
          :keys="indexs"
          :Index="index"
          :key="indexs + '1.' + index"
          :requiredType="requiredType"
          :value.sync="items"
          :rules="rules"
          ref="form-item"
          :disabled="disabled"
        >
        </publicInstitutions-forms>
        <tr
          v-if="number"
          style="  border-bottom:none;border-top:none"
          :key="'number' + index + indexs"
        >
          <td colspan="3">
            <b-form-group
              horizontal
              :label-cols="3"
              :label="`${$lang('FIELD_NUMBER')}：`"
              :key="'number' + index + '|' + indexs"
            >
              <b-form-input
                class="input ui-autocomplete-input"
                style="width: 100%;background: #fff ;"
                type="text"
                v-model="items.number"
                :name="'number' + index + '|' + indexs"
                :class="errors.has(`number${index}|${indexs}`) && 'is-invalid'"
                v-validate="{ required: true }"
                :placeholder="$lang('')"
              />
              <b-form-invalid-feedback
                :state="errors.has(`number${index}|${indexs}`)"
              >
                {{ errors.first(`number${index}|${indexs}`) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </td>
         
        </tr>
        <tr style="    border-top:none;" :key="'slot' + index + indexs">
          <td colspan="3">
            <b-form-group
              horizontal
              :label-cols="3"
              :label="`${$lang('FIELD_CONTACTS_PHONE')}：`"
              :key="'mobile' + index + '|' + indexs"
            >
              <b-form-input
                class="input ui-autocomplete-input"
                style="width: 100%;background: #fff ;"
                type="text"
                v-model="items.mobile"
                :name="'mobile' + index + '|' + indexs"
                :class="errors.has(`mobile${index}|${indexs}`) && 'is-invalid'"
                v-validate="{ ...rules.mobile }"
                :placeholder="$lang('')"
                :disabled="items.disabled"
              />
              <b-form-invalid-feedback
                :state="errors.has(`mobile${index}|${indexs}`)"
              >
                {{ errors.first(`mobile${index}|${indexs}`) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </td>
          <td colspan="3">
            <b-form-group
              horizontal
              :label-cols="3"
              :label="`${$lang('聯繫電郵')}：`"
              :key="'email' + index + '|' + indexs"
            >
              <b-form-input
                class="input ui-autocomplete-input"
                style="width: 100%;background: #fff ;"
                type="text"
                v-model="items.email"
                :name="'email' + index + '|' + indexs"
                :class="errors.has(`email${index}|${indexs}`) && 'is-invalid'"
                v-validate="'email'"
                :placeholder="$lang('')"
                :disabled="items.disabled"
              />
              <b-form-invalid-feedback
                :state="errors.has(`email${index}|${indexs}`)"
              >
                {{ errors.first(`email${index}|${indexs}`) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </td>

          <td>
            <button
              @click.prevent="reset(indexs, index, items)"
              class="btn btn-primary m-0"
              style="font-size: 14px"
            >
              {{ $lang("清空此欄資料") }}
            </button>
          </td>
          <td>
            <button
              v-if="(min && indexs + 1 > min) || (!min && indexs > 0)"
              @click.prevent="handleRemove(item, index, indexs)"
              class="btn btn-danger m-0"
              style="font-size: 14px"
            >
              {{ $lang("刪除此欄") }}
            </button>
          </td>
        </tr>
        <tr
          v-if="
            errors.has(`${item.gameId}|${index}childerror${indexs}`) ||
              items.isPass === false
          "
          :key="'成員' + index + indexs"
        >
          <td style="padding: 0.625em !important" colspan="8">
            <div class="row justify-content-center">
              <b-form-group :key="'error' + index">
                <b-form-input
                  :ref="`${item.gameId}|${index}childerror${indexs}`"
                  class="input ui-autocomplete-input"
                  style="width: 100%; height: 0px; padding: 0; border: none"
                  type="text"
                  :name="item.gameId + '|' + index + 'childerror' + indexs"
                  :class="
                    errors.has(`${item.gameId}|${index}childerror${indexs}`) &&
                      'is-invalid'
                  "
                  v-validate="{ required: false }"
                  :placeholder="$lang('')"
                  :disabled="disabled"
                />
                <b-form-invalid-feedback
                  :state="
                    errors.has(`${item.gameId}|${index}childerror${indexs}`)
                  "
                >
                  {{
                    errors.first(`${item.gameId}|${index}childerror${indexs}`)
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div v-if="items.isPass === false" class="is_open">
              <p style="color: #dc3545">
                {{
                  $lang("PI_GAME_CANCEL").replace(
                    /%game%/,
                    $getLocale() === "zh-hant" ? title.zh_TW : title.pt_PT
                  )
                }}
              </p>
            </div>
          </td>
        </tr>
      </template>
      <div
        v-if="
          (!min && !max) ||
            (min && max && min != max && max > item.gamer.length)
        "
        :key="index + '1.1' + item.index"
        class="add-more my-2 mr-2"
        style="margin-bottom: 0.5rem !important; padding: 0px 10px"
      >
        <a
          style="white-space: nowrap"
          @click="handleAdd(item, index)"
          class="btn btn-success m-0"
          href="javascript:void(0);"
          data-id="198"
          >+{{ $lang("增加參賽者") }}</a
        >
      </div>
    </template>
  </tbody>
</template>

<script>
import PublicInstitutionsForms from "./addteam.vue";
import LeadForms from "./lead.vue";
import { ValidationObserver } from "vee-validate";
export default {
  components: {
    PublicInstitutionsForms,
    ValidationObserver,
    LeadForms,
  },
  props: {
    sportTitle:{},
    subchild: { type: Boolean, default: false },
    subchildindexs: {},
    title: { type: Object },
    canaddteam: {},
    contact: {},
    lead: {},
    gender: {},
    name: {},
    sportId: {},
    id: {},
    inputlist: {},
    max: {
      type: Number,
    },
    min: { type: Number },
    indexs: {},
    value: {
      type: Array,
    },
    number: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Object,
    },
    requiredType: {
      type: Boolean,
    },
  },
  watch: {
    value() {},
  },
  data() {
    return {
      // options: [
      //  lastName: "",
      //         firstName: "",
      //         birthday: "",
      //         gender: "",
      //         idNumber: "",
      //         pic: "",
      //     { text: this.optionYes, value: true },
      //     { text: "否", value: false }]
    };
  },
  computed: {
    options() {
      return [
        { text: this.$lang("boolean.yes"), value: true },
        { text: this.$lang("boolean.no"), value: false },
      ];
    },
  },
  mounted() {},
  methods: {
    numberinput(e, i, is) {
    },
    reset(keys, Index, item) {
      this.$validator.errors.items.forEach((item, indexs) => {
        if (
          item.field ===
          this.value[0].gameId + "|" + Index + "childerror" + keys
        ) {
          this.$validator.errors.items.splice(indexs);
        }
      });

      this.$emit(
        "reset",
        "resetnovalue",
        keys,
        this.indexs,
        this.id,
        this.sportId,
        Index,
        item,
        this.subchild,
        this.subchildindexs
      );
    },
    changeinput(item, index, childIndex, checkobx) {
      console.log(item, index, childIndex);
      // console.log(item,index);
      // console.log(this.value,this.indexs);
      this.$emit(
        "updateValue",
        item,
        index,
        this.indexs,
        this.id,
        this.sportId,
        childIndex,
        checkobx,
        this.subchild,
        this.subchildindexs
      );
    },
    handleRemove(item, slug, index) {
      // console.log(item, slug, index);
      // console.log(this.value[slug].gamer[index]);

      var indexs = this.value[slug].gamer.indexOf(item.gamer[index]);
      // console.log(indexs);
      if (indexs !== -1) {
        this.value[slug].gamer.splice(index, 1);
      }
    },
    handleAdd(item, index) {
      this.value[index].gamer.push({
        noChineseName: false,
        mobile: "",
        number: "",
        email: "",
        lastNameOther: "",
        firstNameOther: "",
        lastName: "",
        firstName: "",
        birthday: "",
        gender: "",
        idNumber: "",
        pic: "",
        idType: "",
        disabled: false,
      });
    },
    async onSubmit() {
      return new Promise((resolve, reject) => {
        var promise_list = this.$refs["form-item"].map((item) => {
          return item.onSubmit();
        });
        this.$validator.validateAll().then((validate) => {
          if (validate) {
            Promise.all(promise_list).then((list) => {
              var result = list.every((item) => item);
              this.errorScoll();
              resolve(result);
              reject(result);
              // console.log(result);
            });
          } else {
            this.errorScoll();
          }
        });
      });
    },
    errorScoll() {
      let errEle = document.querySelector(".is-invalid");
      errEle ? this.animateScroll(errEle, 50) : "";
    },
    getIndex() {
      return this.indexs;
    },
    getSportId() {
      return this.value[0].gameId;
    },
    getError(e) {
      e.forEach((item) => {
        if (item.gamerKey !== null) {
          console.log(this.$validator.errors.items.length, "length");
          if (this.$validator.errors.items.length > 0) {
            this.$validator.errors.items.forEach((items, indexs) => {
              console.log(
                items.field,
                this.value[0].gameId +
                  "|" +
                  item.teamKey +
                  "childerror" +
                  item.gamerKey
              );
              if (
                items.field ===
                this.value[0].gameId +
                  "|" +
                  item.teamKey +
                  "childerror" +
                  item.gamerKey
              ) {
                this.$validator.errors.items[indexs].msg =
                  this.$validator.errors.items[indexs].msg +
                  "," +
                  this.$lang(item.message);
              } else {
                this.validateErrors(
                  this.value[0].gameId +
                    "|" +
                    item.teamKey +
                    "childerror" +
                    item.gamerKey,
                  this.$lang(item.message)
                );
              }
            });
          } else {
            this.validateErrors(
              this.value[0].gameId +
                "|" +
                item.teamKey +
                "childerror" +
                item.gamerKey,
              this.$lang(item.message)
            );
          }

          // console.log(this.value[0].gameId + "submiterror" + item.teamKey);
        } else {
          console.log(this.$validator.errors.items.length, "length");
          if (this.$validator.errors.items.length > 0) {
            this.$validator.errors.items.forEach((items, indexs) => {
              console.log(
                items.field,
                this.value[0].gameId + "submiterror" + item.teamKey
              );
              if (
                items.field ===
                this.value[0].gameId + "submiterror" + item.teamKey
              ) {
                this.$validator.errors.items[indexs].msg =
                  this.$validator.errors.items[indexs].msg +
                  "," +
                  this.$lang(item.message);
              } else {
                this.validateErrors(
                  this.value[0].gameId + "submiterror" + item.teamKey,
                  this.$lang(item.message)
                );
              }
            });
          } else {
            this.validateErrors(
              this.value[0].gameId + "submiterror" + item.teamKey,
              this.$lang(item.message)
            );
          }
        }
      });
      console.log(this.$validator.errors.items, "result");
      this.errorScoll();
      // console.log(this.$refs["form-item"],123);
    },
    animateScroll(element, speed) {
      //获取元素相对窗口的top值，此处应加上窗口本身的偏移
      let top = window.pageYOffset + element.getBoundingClientRect().top;
      // 获取当前距离窗口的top值
      let osTop = document.documentElement.scrollTop || document.body.srcollTop;
      let requestId;
      let currentNumber = 0;
      //采用requestAnimationFrame，平滑动画
      function step() {
        if (osTop >= top) {
          currentNumber = osTop -= speed;
          window.scrollTo(0, osTop);
          requestId = window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(requestId);
        }
      }
      window.requestAnimationFrame(step);
    },
    validateErrors(field, msg) {
      this.errors.add({
        field,
        msg,
      });
    },
  },
};
</script>
